import { render, staticRenderFns } from "./onlineManagement.vue?vue&type=template&id=2307fd48&"
import script from "./onlineManagement.vue?vue&type=script&lang=js&"
export * from "./onlineManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports